import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router';
import { AuthError, exchangeCode } from '../../auth/cognito.js';
import { useSession } from '../../session/SessionProvider.js';
import { InlineError } from '../../ui/index.js';
import { AuthLayout, AuthTitle } from './AuthLayout.js';
import styles from './Auth.module.css';

/** Where Google sends DinoCloud staff back. Exchanges the code and enters the hub. */
export function Callback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { signInWithTokens } = useSession();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const code = params.get('code');
    const state = params.get('state');
    const denied = params.get('error_description') ?? params.get('error');
    if (denied) {
      // Cognito surfaces our trigger's refusal text after a fixed prefix.
      setError(denied.replace(/^.*failed with error /, ''));
      return;
    }
    if (!code || !state) {
      setError('The sign-in did not complete. Start again.');
      return;
    }
    exchangeCode(code, state)
      .then((tokens) => signInWithTokens(tokens))
      .then(() => navigate('/', { replace: true }))
      .catch((err: unknown) => setError(err instanceof AuthError ? err.message : 'Google sign-in did not complete. Try again.'));
  }, [params, navigate, signInWithTokens]);

  return (
    <AuthLayout>
      <div className={styles.form}>
        <AuthTitle title={error ? 'Sign-in did not complete' : 'Signing you in'} description={error ? undefined : 'One moment.'} />
        {error && <InlineError>{error}</InlineError>}
        {error && (
          <div className={styles.links}>
            <Link to="/auth/sign-in">Back to sign in</Link>
          </div>
        )}
      </div>
    </AuthLayout>
  );
}
